import { device } from '@constants/mediaQueries';
import { css, styled } from '@mui/material';
import Button from '@mui/material/Button';
import MUITypography from '@mui/material/Typography';
import { LinkProps } from 'react-router-dom';

const shouldForwardProp = (prop: string) => prop !== 'error' && prop !== 'margin';

export const TextContainer = styled('div', { shouldForwardProp })<{ margin?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  text-align: left;
  gap: 1rem;
  @media only screen and ${device.mobileOrTablet} {
    align-items: center;
    text-align: center;
  }
  ${({ margin, theme }) =>
    margin &&
    css`
      margin-left: ${theme.spacing(6)};
      @media only screen and ${device.mobileOrTablet} {
        margin-left: 0;
        margin-top: ${theme.spacing(4)};
      }
    `}
`;

export const DescriptionHeader = styled(MUITypography, { shouldForwardProp })<{ error?: boolean }>`
  ${({ theme }) => css`
    font-size: ${theme.typography.body1.fontSize};
    font-weight: ${theme.typography.fontWeightBold};
  `}
  text-wrap: balance;
  ${({ error }) =>
    error &&
    css`
      color: #f64f46;
    `}
  margin-bottom: 1.5rem;
`;

export const DescriptionText = styled(MUITypography)`
  ${({ theme }) => css`
    font-size: ${theme.typography.body1.fontSize};
  `}
  text-wrap: balance;
  & > a {
    color: inherit;
    text-decoration: underline;
  }
  & > span {
    font-weight: bold;
  }
`;

export const RetryButton = styled(Button)<LinkProps>`
  ${({ theme }) => css`
    font-size: ${theme.typography.body1.fontSize};
    font-weight: ${theme.typography.h1.fontWeight};
  `};
  text-transform: unset;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.light};
  }
  .MuiButton-endIcon {
    margin-left: 1rem;
  }
  margin-top: 1.5rem;
`;
